"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelActionButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const PanelIconWrapper_1 = require("./PanelIconWrapper");
require("./types");
const StyledButton = styled_components_1.default(components_1.Button) `
  min-width: ${({ theme }) => theme.sizes.fields.xxs};
`;
const PanelActionButton = ({ id = '', disabled, text, icon, view, onClick, loading, }) => {
    const Icon = typeof icon === 'string' ? react_1.default.createElement(components_1.Icon, { src: icon, disabled: disabled || loading }) : icon;
    return (react_1.default.createElement(StyledButton, { ui: view, disabled: disabled || loading, onClick: onClick, "data-selector-id": id },
        react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.s, align: components_1.STACK_ALIGN.center, distribution: icon ? components_1.STACK_DISTRIBUTION.start : components_1.STACK_DISTRIBUTION.center },
            Icon && react_1.default.createElement(PanelIconWrapper_1.PanelIconWrapper, null, Icon),
            react_1.default.createElement(components_1.Text, { view: components_1.TEXT_VIEW.inherit }, text))));
};
exports.PanelActionButton = PanelActionButton;
exports.PanelActionButton.displayName = 'PanelActionButton';
//# sourceMappingURL=PanelActionButton.js.map